
import React from 'react';
import Checkbox from '../../../Checkbox';

const Checklist = ({ checklists, edit, handleItemChecked }) =>
    <div className="dedroom_content_box">
        <div class="title_chack_box">
            <h3>Checklist</h3>
        </div>
        <div class="checklist">
            {checklists.map(item => {
                return (
                    <Checkbox
                        label={item.description}
                        value={item.ischecked}
                        onChange={() =>
                            edit ? handleItemChecked(item) : null}
                    />
                )
            }
            )}
        </div>
    </div>

export default Checklist;